// extracted by mini-css-extract-plugin
export default {"container":"SimpleLoader_container__IMnJV","text":"SimpleLoader_text__F+9gH","loader":"SimpleLoader_loader__5bkpw"};